export const getArreactProdList = {
  url: '/admin/businessProd/pageBusinessProd',
  method: 'get'
};

export const attractProductUpdateStatus = {
  url: '/admin/businessProd/updateStatus',
  method: 'post'
};

export const attractProductUpdateTop = {
  url: '/admin/businessProd/updateTop',
  method: 'post'
};

export const getAttractConfig = {
  url: '/miniapp/wxuser/getUserConfigDict.json',
  method: 'get'
};

export const getAttractAreaList = {
  url: '/admin/businessProd/getBusinessAreaConfigList',
  method: 'get'
};

export const saveAttractProduct = {
  url: '/admin/businessProd/saveOrUpdate',
  method: 'post'
};

export const getAttractProductDetail = {
  url: '/admin/businessProd/getBusinessProdInfo',
  method: 'get'
};

export const getAttractBannerList = {
  url: '/admin/businessSlideConfig/page',
  method: 'get'
};

export const saveAttractBanner = {
  url: '/admin/businessSlideConfig/saveOrUpdate',
  method: 'post'
};

export const attractBannerUpdateStatus = {
  url: '/admin/businessSlideConfig/updateStatus',
  method: 'post'
};

export const delAttractBanner = {
  url: '/admin/businessSlideConfig/deleteByIds',
  method: 'post'
};

export const getAttractApplyList = {
  url: '/admin/businessApply/getBusinessAgentApplyList.json',
  method: 'get'
};

export const getAttractApplyDetail = {
  url: '/admin/businessApply/getBusinessAgentApplyDetail.json',
  method: 'get'
};
